import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type PrivateInfluencer from "./PrivateInfluencer";

interface Address {
  addressLine1: string;
  addressLine2: string;
  addressLine3: string;
  city: string;
  country: string;
  county: string;
  postalCode: string;
  state: string;
}

@Model()
class PrivateInfluencerAddress extends ApplicationRecord {
  static jsonapiType = "private_influencer_addresses";

  @Attr() address: Address;

  @Attr() defaultFlag: boolean;

  @BelongsTo() privateInfluencer: PrivateInfluencer;
}

export default PrivateInfluencerAddress;
